export default "__VITE_PUBLIC_ASSET__ce2bec44__"